module.exports = __webpack_public_path__ + "static/media/the_gallows.99e34899.jpg";